import { SemanticIndicatorColors } from "@/styles/nawy-theme/foundation/colors/semantic";

export enum FollowUpStatusEnum {
  PENDING = "pending",
  RESOLVED = "resolved",
  NO_FOLLOW_UP = "no-follow-up",
}

export const FollowUpStatusColors: Partial<
  Record<FollowUpStatusEnum, SemanticIndicatorColors>
> = {
  [FollowUpStatusEnum.PENDING]: "red",
  [FollowUpStatusEnum.RESOLVED]: "green",
};
